import {
  makeStyles,
  Drawer,
  Button,
  Paper,
  Grid,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Dialog,
  DialogContent,
  Menu,
  MenuItem,
} from "@material-ui/core";

import React, { useState, useEffect } from "react";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { Select, Input as AntInput } from "antd";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from "@material-ui/icons/Edit";

import ContractSummaryTab from "./components/ContractSummaryTab";
import CostPlus from "./components/CostPlus";
import CustomSelect from "../../common-components/CustomSelect";
import CustomTextField from "../../common-components/CustomTextField";
import CloseIcon from "@material-ui/icons/Close";
import FileUpload from "../../common-components/FileUpload";
import {
  financeViewTypes,
  expenseTypes,
  PLData,
  heatMapColors,
  yesNoDdl,
} from "../../shared-resources/dumpData";
import { pipelineUsers } from "../../shared-resources/constants";
import {
  UploadIcon,
  DownloadTemplateIcon,
  DownloadIcon,
} from "../../shared-resources/SVGIcons";
import Loading from "../../common-components/Loading";
import ActionMessages from "../../common-components/ActionMessages";
import { setUnsavedChangesUnnamed } from "../../actions/common-actions";
import { getRMFieldSettings } from "../../actions/admin-actions";
import {
  getContractSummary,
  getDirectLaborDetails,
  getOtherDirectCostsDetails,
  getMargin,
  getRevenue,
  clearCostplusData,
  getDropdownOptions,
  getDetailedViewRates,
  getContractSummaryCostPlus,
  getContractSummaryEAC,
  updateDetailedViewRates,
  getListOfContracts,
  downloadDetailedView,
  downloadPsr,
  getListOfVersions,
  getDetailedViewHeaders,
  setSelectedOppYear,
} from "../../actions/financial-management-actions";
import PSRTrend from "./components/PSRTrend";
import PsrDownloadDialog from "./components/PsrDownloadDialog";
import IndirectSummaryTab from "./components/IndirectSummaryTab";
import Fringe from "./components/Fringe";
import { downloadFile } from "../../shared-resources/utils";
import {
  addResourceToContractAPI,
  getProjectClinsAPI,
  getAddResourceDetailsForContractAPI,
  getContractClinRatesAPI,
  updateContractClinRatesAPI,
  getClinsForOdcAPI,
  addNewOdcAPI,
  unnamedResourceNotesAPI,
  downloadDetailedViewTemplateAPI,
  uploadDetailedViewAPI,
  updateClinRevisedEndDateAPI,
  getFinancialYearOptionsAPI,
  getFinancialYearOptionsPSRAPI,
  updateRevenueAPI,
  updateOtherDirectCostsDetailsAPI,
  updateDirectLaborDetailsAPI,
  getHeatMapAPI,
  getAssumptionAPI,
  resourceListForClinAPI,
  clinForHeatMapAPI,
  clinForExtraDetailsAPI,
  updateHeatMapAPI,
  getClinLevelDetailsAPI,
  updateClinLevelDetailsAPI,
  getOvertimeTypesAPI,
  downloadOpportunityListAPI,
  getWeeklyEACClinDropdownAPI,
  getWeeklyEACDirectLaborAPI,
  downloadWeeklyEACDirectLaborAPI,
  downloadWeeklyEACBulkClinSummaryAPI,
} from "../../api/financial-management-api";
import Pipeline from "./components/Pipeline";
import WeeklyEACs from "./components/WeeklyEACs";
import WeeklyEACTemplateActions from "./components/weekly-eac/WeeklyEACTemplateActions";

const { TextArea } = AntInput;

const contractYears = [
  { id: "001", text: "001" },
  { id: "002", text: "002" },
  { id: "003", text: "003" },
  { id: "004", text: "004" },
];

const defaultNewClin = {
  clin: "",
  pOLine: "",
  pn: "",
  employeeSubConId: "",
  lCatId: "",
  lCatDescription: "",
  laborEscalation: 0,
  billRate: 0,
  costRateUnloaded: "",
  templateType: "",
  contractId: "",
  contractYear: "",
  notes: "",
  employmentTypeId: "",
  employeeSubConId: "",
  applyBurden: true,
  isIwo: false,
};

const defaultNewODC = {
  clin: "",
  expenseType: "",
  applyBurden: true,
};

const defaultNewHeatmap = {
  clin: "",
  culture: "",
  customer: "",
  doge: "",
  financial: "",
  funding: "",
  perform: "",
  staffing: "",
  vacantFte: "",
};

// const ratesData = [
//   {
//     clin: "21702.003.301",
//     feeNonLabor: 25,
//     feeLabor: 35,
//     feeSubCon: 30,
//   },
//   {
//     clin: "21702.003.303",
//     feeNonLabor: 20,
//     feeLabor: 36,
//     feeSubCon: 32,
//   },
//   {
//     clin: "21702.003.305",
//     feeNonLabor: 20,
//     feeLabor: 38,
//     feeSubCon: 32,
//   },
//   {
//     clin: "21702.003.307",
//     feeNonLabor: 22,
//     feeLabor: 40,
//     feeSubCon: 35,
//   },
//   {
//     clin: "21702.003.309",
//     feeNonLabor: 50,
//     feeLabor: 40,
//     feeSubCon: 45,
//   },
//   {
//     clin: "21702.003.312",
//     feeNonLabor: 22,
//     feeLabor: 50,
//     feeSubCon: 45,
//   },
//   {
//     clin: "21702.003.315",
//     feeNonLabor: 60,
//     feeLabor: 80,
//     feeSubCon: 55,
//   },
// ];

const useStyles = makeStyles((theme) => ({
  tabPaper: {
    padding: "12px 24px",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "8px",
    marginBottom: "12px",
  },
  componentStyles: {
    margin: "16px",
  },
  firstTabDiv: {
    marginTop: "18px",
  },
  secondTabDiv: {
    marginTop: "18px",
  },
  thirdTabDiv: {
    marginTop: "18px",
  },
  firstSelectedTab: {
    marginLeft: "30px",
    fontSize: "15px",
    fontWeight: 600,
    color: "#0070D2",
    cursor: "pointer",
  },
  nonFirstNonSelectedTab: {
    marginLeft: "30px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
  },
  secondSelectedTab: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#0070D2",
    cursor: "pointer",
  },
  secondNonSelectedTab: {
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
  },
  thirdSelectedTab: {
    marginRight: "30px",
    fontSize: "15px",
    fontWeight: 600,
    color: "#0070D2",
    cursor: "pointer",
  },
  thirdNonSelectedTab: {
    marginRight: "30px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
  },
  firstSelectedTabHr: {
    width: "20%",
    height: "5px",
    marginLeft: "25px",
    marginTop: "4px",
    backgroundColor: "#0070D2",
    borderRadius: "20px",
    border: "1px solid #0070D2",
  },
  nonFirstNonSelectedTabHr: {
    width: "20%",
    height: "5px",
    marginLeft: "25px",
    backgroundColor: "#ffffff",
    borderRadius: "20px",
    border: "1px solid #ffffff",
  },
  secondSelectedTabHr: {
    width: "110%",
    height: "5px",
    marginLeft: "-2px",
    marginTop: "4px",
    backgroundColor: "#0070D2",
    borderRadius: "20px",
    border: "1px solid #0070D2",
  },
  nonSecondNonSelectedTabHr: {
    width: "110%",
    height: "5px",
    marginLeft: "-2px",
    backgroundColor: "#ffffff",
    borderRadius: "20px",
    border: "1px solid #ffffff",
  },
  thirdSelectedTabHr: {
    width: "80%",
    height: "5px",
    marginLeft: "-3px",
    marginTop: "4px",
    backgroundColor: "#0070D2",
    borderRadius: "20px",
    border: "1px solid #0070D2",
  },
  nonThirdNonSelectedTabHr: {
    width: "80%",
    height: "5px",
    marginLeft: "-3px",
    backgroundColor: "#ffffff",
    borderRadius: "20px",
    border: "1px solid #ffffff",
  },
  selectedLabel: {
    color: "#0070D2",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  addDialog: {
    width: "700px",
    height: "auto",
    position: "relative",
  },
  addDialogODC: {
    width: "400px",
    height: "auto",
    position: "relative",
  },
  addDialogHeatmap: {
    width: "700px",
    height: "auto",
    position: "relative",
  },
  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  viewRatePopupBtn: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
  },
  saveBtn: {
    fontSize: "12px",
    padding: "4px 8px !important",
    textTransform: "none",
    background: "#0176D3",
    marginRight: "8px",
  },

  updateBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginRight: "8px",
  },

  editIcon: {
    color: "#0070D2",
    fontSize: "14px",
    float: "left",
    marginTop: "2px",
  },
  editText: {
    color: "#0070D2",
    marginLeft: "4px",
    fontWeight: 600,
    fontSize: "13px",
  },
  editBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "2px 8px",
    cursor: "pointer",
  },
  cancelBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
  },
  cancelBtnPopup: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
    fontSize: "13px",
  },
  table: {
    width: "100%",
    marginTop: theme.spacing(1),
    borderCollapse: "collapse",
    backgroundColor: "#e6eaeb", // Milky white background for the table
  },
  tableCellInput: {
    width: "100%",
    padding: "5px",
  },
  tableContainer: {
    maxHeight: 500,
    overflowY: "auto",
  },
  tableHeader: {
    backgroundColor: "#01539a",
    color: "white",
    fontWeight: "bold",
  },
  tableCell: {
    padding: theme.spacing(1),
    textAlign: "left",
  },
  zebraRow: {
    backgroundColor: "#f5f5f5",
  },
  zebraRowDark: {
    backgroundColor: "#fff",
  },
  closeSection: {
    position: "absolute",
    cursor: "pointer",
    right: theme.spacing(0.25),
    top: theme.spacing(0.25),
  },
  closeIcon: {
    color: "#C4C4C4",
  },
  drawerDataSection: {
    position: "relative",
    padding: "6px 32px",
  },
  drawerTitle: {
    color: "#0082CA",
    fontSize: theme.spacing(2.25),
    marginBottom: theme.spacing(2),
  },
  uploadDescription: {
    marginBottom: theme.spacing(2),
  },
}));

const deepCopyObject = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

export default function FinancialDashboard() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const module = localStorage.getItem("module");
  const modules = module ? module.split(",").map((m) => m.trim()) : [];
  const [pageType, setPageType] = useState("detail");
  const [detailedType, setDetailedType] = useState("");
  const [yearValue, setYearValue] = useState("");
  const [weeklyEACClin, setWeeklyEACClin] = useState("");
  const [weeklyEACClinOptions, setWeeklyEACClinOptions] = useState([]);
  const [weeklyEACDirectLaborData, setWeeklyEACDirectLaborData] =
    useState(null);
  const [weeklyEACDirectLaborLoading, setWeeklyEACDirectLaborLoading] =
    useState(false);
  const [weeklyEACDownloading, setWeeklyEACDownloading] = useState(false);
  const [weeklyEACDownloadMenuAnchor, setWeeklyEACDownloadMenuAnchor] =
    useState(null);
  const [yearValuePipeline, setYearValuePipeline] = useState();
  //const [viewType, setViewType] = useState("Monthly");
  const [selectedContract, setSelectedContract] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingHeatmap, setLoadingHeatmap] = useState(false);
  const [loadingPipeline, setLoadingPipeline] = useState(false);
  const [contractYearValue, setContractYearValue] = useState("");
  const [sectionType, setSectionType] = useState(modules[0] || module);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [isSaveClick, setIsSaveClick] = useState(false);
  const [isRatesSaveClick, setIsRatesSaveClick] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [version, setVersion] = useState();
  const [ratesYear, setRatesYear] = useState();
  const [versions, setVersions] = useState([]);

  const [isDownloadClick, setIsDownloadClick] = useState(false);
  const [isDownloadPsrClick, setIsDownloadPsrClick] = useState(false);
  const [showPsrDownloadDialog, setShowPsrDownloadDialog] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditFee, setIsEditFee] = useState(false);
  const [showDialogNew, setShowDialogNew] = useState(false);
  const [showDialogODC, setShowDialogODC] = useState(false);
  const [clinFormData, setClinFormData] = useState(defaultNewClin);
  const [clinFormDataODC, setClinFormDataODC] = useState(defaultNewODC);
  const [heatMapFormData, setHeatMapFormData] = useState(defaultNewHeatmap);
  const [newClins, setNewClins] = useState([]);
  const [newClinsODC, setNewClinsODC] = useState([]);
  const [newClinEmployees, setNewClinEmployees] = useState([]);
  const [rmSettingsData, setRmSettingsData] = useState([]);
  const [viewRatesDataFromAPI, setViewRatesDataFromAPI] = useState([]);
  const [viewRatesData, setViewRatesData] = useState([]);
  const [updatedViewRatesData, setUpdatedViewRatesData] = useState([]);
  const [showDialogViewRates, setShowDialogViewRates] = useState(false);
  const [tableEditable, setTableEditable] = useState(false);
  const [isSaveClickUpdateRates, setIsSaveClickUpdateRates] = useState(false);
  const [selectedDirectLabor, setSelectedDirectLabor] = useState();
  const [isEditDetails, setIsEditDetails] = useState(false);
  const [openDrawerUpload, setOpenDrawerUpload] = useState(false);
  const [showPipelineFinancialYear, setShowPipelineFinancialYear] =
    useState(false);
  const [openDrawerUploadPipeline, setOpenDrawerUploadPipeline] =
    useState(false);
  const [financialYears, setFinancialYears] = useState([]);
  const [financialYearsPipeline, setFinancialYearsPipeline] = useState([]);
  const [opportunities, setOpportunities] = useState([
    { value: "Opp 1", label: "Opp 1" },
    { value: "Opp 2", label: "Opp 2" },
    //{ value: -1, label: "Add New" },
  ]);
  const [selectedOpportunity, setSelectedOpportunity] = useState("Opp 1");
  const [isYearAPICalled, setIsYearAPICalled] = useState(false);
  const [heatMapData, setHeatMapData] = useState([]);
  const [clinDetailsData, setClinDetailsData] = useState([]);
  const [assumptionData, setAssumptionData] = useState();
  const [employees, setEmployees] = useState([]);
  const [plData, setPlData] = useState(PLData);
  const [isAddOpp, setIsAddOpp] = useState(false);
  const [pipelineFilteredOppNos, setPipelineFilteredOppNos] = useState([]);
  const [showAddHeatMap, setShowAddHeatMap] = useState(false);
  const [clinsForHeatmap, setClinsForHeatmap] = useState([]);
  const [clinsForDetails, setClinsForDetails] = useState([]);
  const [otTypes, setOtTypes] = useState([]);

  const contractSummaryData = useSelector(
    (state) => state.financialManagementReducer.contractSummaryData,
  );

  const contractSummaryCostPlusData = useSelector(
    (state) => state.financialManagementReducer.contractSummaryCostPlusData,
  );

  const loadingAPI = useSelector(
    (state) => state.financialManagementReducer.loadingAPI,
  );

  const directLaborDetailsData = useSelector(
    (state) => state.financialManagementReducer.directLaborDetailsData,
  );

  const contractsData = useSelector(
    (state) => state.financialManagementReducer.contractsData,
  );

  const otherDirectCostData = useSelector(
    (state) => state.financialManagementReducer.otherDirectCostData,
  );

  const revenueData = useSelector(
    (state) => state.financialManagementReducer.revenueData,
  );

  const marginData = useSelector(
    (state) => state.financialManagementReducer.marginData,
  );

  const detailedViewRatesData = useSelector(
    (state) => state.financialManagementReducer.detailedViewRatesData,
  );

  const updateDetailedRatesData = useSelector(
    (state) => state.financialManagementReducer.updateDetailedRatesData,
  );

  const downloadDetailedViewData = useSelector(
    (state) => state.financialManagementReducer.downloadDetailedViewData,
  );

  const downloadpsrData = useSelector(
    (state) => state.financialManagementReducer.downloadPsrData,
  );

  const versionsData = useSelector(
    (state) => state.financialManagementReducer.versionsData,
  );

  const rmFieldSettingsData = useSelector(
    (state) => state.adminReducer.rmFieldSettingsData,
  );

  const detailedViewHeadersData = useSelector(
    (state) => state.financialManagementReducer.detailedViewHeadersData,
  );

  const opportunityYearsList = useSelector(
    (state) => state.financialManagementReducer.opportunityYearsList,
  );

  useEffect(() => {
    if (opportunityYearsList && opportunityYearsList.length > 0) {
      const years = [];
      opportunityYearsList.forEach((val) => {
        years.push({ id: val, text: val });
      });
      setYearValuePipeline(opportunityYearsList[0]);
      dispatch(setSelectedOppYear(opportunityYearsList[0]));
      setFinancialYearsPipeline(years);
    } else {
      setFinancialYearsPipeline([]);
    }
  }, [opportunityYearsList]);

  const getViewRates = () => {
    getContractClinRatesAPI(selectedContract, detailedType, version, yearValue)
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.rateList &&
          Array.isArray(res.data.rateList) &&
          res.data.rateList.length > 0
        ) {
          const cleanedData = res.data.rateList.map((item) => ({
            ...item,
            feeLabor: isNaN(item.feeLabor) ? 0 : Number(item.feeLabor),
            feeNonLabor: isNaN(item.feeNonLabor) ? 0 : Number(item.feeNonLabor),
            feeSubCon: isNaN(item.feeSubCon) ? 0 : Number(item.feeSubCon),
          }));

          setViewRatesData(deepCopyObject(cleanedData));
          setViewRatesDataFromAPI(deepCopyObject(cleanedData));
          setUpdatedViewRatesData(deepCopyObject(cleanedData));
        }
      })
      .catch((err) => {
        console.error("Error fetching rates data:", err);
      });
  };

  const getDetailedViewData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        dispatch(
          getDirectLaborDetails(
            selectedContract,
            detailedType,
            contractYearValue,
            version,
            yearValue,
          ),
        ),
        dispatch(
          getOtherDirectCostsDetails(
            selectedContract,
            detailedType,
            contractYearValue,
            version,
            yearValue,
          ),
        ),
        dispatch(
          getRevenue(
            selectedContract,
            detailedType,
            contractYearValue,
            version,
            yearValue,
          ),
        ),
        dispatch(
          getMargin(
            selectedContract,
            detailedType,
            contractYearValue,
            version,
            yearValue,
          ),
        ),
      ]);
    } catch (err) {
      console.error("Failed to fetch detailed view data", err);
    } finally {
      setLoading(false);
    }
  };

  const getResourceId = (val) => {
    return newClinEmployees.filter((emp) => emp.employeeId === val)[0]
      .resourceId;
  };

  const hadTemplate = (type) => {
    return contractsData.data.filter(
      (val) => val.contractId === selectedContract,
    )[0][type];
  };

  const defaultTemplate = () => {
    if (hadTemplate("showCostPlus")) return "Cost Plus";
    else if (hadTemplate("showTM")) return "TM";
    else if (hadTemplate("showFFP")) return "FFP";
    return "";
  };

  const onAddHeatmap = () => {
    const insertData = [heatMapFormData];
    setLoadingHeatmap(true);
    updateHeatMapAPI(insertData, selectedContract).then((res) => {
      if (res.status === 200) {
        setShowAddHeatMap(false);
        setMsgType("success");
        setEmptyErrMsg(true);
        setMsgText("Updated data successfully");
        getHeatMapAPI(selectedContract).then((res) => {
          setLoadingHeatmap(false);
          setHeatMapData(res.data);
        });
      }
      if (res.status === 400) {
        setLoadingHeatmap(false);
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText(res.message);
      }
    });
  };

  const handleChangeDetailedType = (e) => {
    if (isEdit || isEditFee) {
      if (
        window.confirm("There are unsaved changes. Do you want to go away?")
      ) {
        setDetailedType(e.target.value);
        setIsEdit(false);
        setIsEditFee(false);
        return;
      } else {
        return;
      }
    }
    setDetailedType(e.target.value);
  };

  const getLcatIds = () => {
    const clin = newClins.find((val) => val.clin === clinFormData.clin);
    if (!clin?.listOfLCATIds?.length) return [];
    return clin.listOfLCATIds.map((item) => ({
      value: item.LCATId,
      label: `${item.LCATId} - ${item.LCATDescription}`,
      billRate: item.billRate,
    }));
  };

  const getEmployees = () => {
    const items = [];
    employees.forEach((emp) => {
      if (
        clinFormData.employmentTypeId === "" ||
        emp.employee_type ===
          ddlItemName("Employment Type", clinFormData.employmentTypeId)
      )
        items.push({
          value: emp.empl_id,
          label: emp.resource_name,
        });
    });
    return items;
  };

  const onChangeYear = (val) => {
    setYearValue(val);
  };

  const onChangeYearPipeline = (val) => {
    setYearValuePipeline(val);
    dispatch(setSelectedOppYear(val));
  };

  const onChangeViewType = (e) => {
    //setViewType(e.target.value);
  };

  const handleChangePageType = (val) => {
    if (isEdit || isEditFee) {
      if (
        window.confirm("There are unsaved changes. Do you want to go away?")
      ) {
        setPageType(val);
        setIsYearAPICalled(false);
        setDetailedType(defaultTemplate());
        setIsEdit(false);
        setIsEditFee(false);
        return;
      } else {
        return;
      }
    }
    setPageType(val);
    setIsYearAPICalled(false);
    setDetailedType(defaultTemplate());
  };

  const handleAddNewDirectLabor = () => {
    setShowDialogNew(true);
    setClinFormData(defaultNewClin);
  };

  const handleAddNewODC = () => {
    setShowDialogODC(true);
    setClinFormDataODC(defaultNewODC);
  };

  const updateClinReviseDate = (data) => {
    setLoading(true);
    updateClinRevisedEndDateAPI(data, version, yearValue).then((res) => {
      if (res.status === 200) {
        setLoading(false);
        setMsgType("success");
        setEmptyErrMsg(true);
        setMsgText("Updated CLIN revised end date successfully");
        getDetailedViewData();
        dispatch(
          getDetailedViewHeaders(
            selectedContract,
            detailedType,
            version,
            yearValue,
          ),
        );
        getYears(false);
      }
      if (res.status === 400) {
        setLoading(false);
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText(res.message);
      }
    });
  };

  const onAddODC = () => {
    const insertData = { ...clinFormDataODC };
    insertData.contractId = selectedContract;
    insertData.templateType = detailedType;
    setLoading(true);
    addNewOdcAPI(insertData, version, yearValue).then((res) => {
      if (res.status === 200) {
        setShowDialogODC(false);
        //setLoading(false);
        setMsgType("success");
        setEmptyErrMsg(true);
        setMsgText("Added ODC successfully");
        getDetailedViewData();
      }
      if (res.status === 400) {
        setLoading(false);
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText(res.message);
      }
    });
  };

  const onAddDirectLabor = () => {
    if (isEditDetails) {
      setLoading(true);
      const insertData = { ...selectedDirectLabor };
      insertData.notes = clinFormData.notes;
      unnamedResourceNotesAPI(insertData).then((res) => {
        if (res.status === 200) {
          setShowDialogNew(false);
          setLoading(false);
          setMsgType("success");
          setEmptyErrMsg(true);
          setIsEditDetails(false);
          setMsgText("Updated CLIN successfully");
          dispatch(
            getDirectLaborDetails(
              selectedContract,
              detailedType,
              contractYearValue,
              version,
              yearValue,
            ),
          );
        }
        if (res.status === 400) {
          setLoading(false);
          setMsgType("error");
          setEmptyErrMsg(true);
          setMsgText(res.message);
        }
      });
    } else {
      const insertData = { ...clinFormData };
      insertData.contractId = selectedContract;
      insertData.contractYear = contractYearValue;
      insertData.templateType = detailedType;
      insertData.lCatId = (insertData.lCatId ?? "").toString().trim();
      insertData.lCatDescription = (insertData.lCatDescription ?? "")
        .toString()
        .trim();
      const lcatOptions = getLcatIds();
      const hasManualLcat = clinFormData.clin && lcatOptions.length === 0;
      if (hasManualLcat) {
        const hasId = insertData.lCatId !== "";
        const hasDesc = insertData.lCatDescription !== "";
        if (hasId !== hasDesc) {
          setMsgType("error");
          setEmptyErrMsg(true);
          setMsgText(
            "Please enter both LCAT Id and LCAT Description, or leave both empty",
          );
          return;
        }
      } else {
        insertData.lCatDescription =
          insertData.lCatId === ""
            ? ""
            : newClins
                .filter((val) => val.clin === insertData.clin)[0]
                .listOfLCATIds.filter(
                  (item) =>
                    item.LCATId.toString() === insertData.lCatId.toString(),
                )[0].LCATDescription;
      }
      insertData.employmentTypeId = insertData.employmentTypeId.toString();
      setLoading(true);
      addResourceToContractAPI(insertData, version, yearValue).then((res) => {
        if (res.status === 200) {
          setShowDialogNew(false);
          // setLoading(false);
          setMsgType("success");
          setEmptyErrMsg(true);
          setMsgText("Added CLIN successfully");
          getDetailedViewData();
        }
        if (res.status === 400) {
          setLoading(false);
          setMsgType("error");
          setEmptyErrMsg(true);
          setMsgText(res.message);
        }
      });
    }
  };

  const onChangeOpportunity = (value) => {
    if (value !== -1) {
      setPlData(PLData);
      setIsAddOpp(false);
    } else {
      setPlData({
        plData: [
          {
            id: 0,
            includeInForecast: "Yes",
            salesforceOrManual: "Manual",
            federal: "",
            opportunityNumber: "",
            opportunityName: "",
            closedDate: null,
            forecastCategory: "",
            revenue: 0,
            directLabor: 0,
            subContractor: 0,
            grossProfit: 0,
            odcs: 0,
            indirectCosts: 0,
            netMargin: 0,
          },
        ],
        adjustment: { revenue: 0 },
      });
      setIsAddOpp(true);
    }
    setSelectedOpportunity(value);
  };

  const onChangeContract = (value) => {
    if (isEdit || isEditFee) {
      if (
        window.confirm("There are unsaved changes. Do you want to go away?")
      ) {
        setSelectedContract(value);
        setPageType("detail");
        setViewRatesData([]);
        setViewRatesDataFromAPI([]);
        setUpdatedViewRatesData([]);
        dispatch(clearCostplusData());
        setIsYearAPICalled(false);
        setIsEdit(false);
        setIsEditFee(false);
        return;
      } else {
        return;
      }
    }
    setIsYearAPICalled(false);
    setDetailedType("");
    setSelectedContract(value);
    setPageType("detail");
    setViewRatesData([]);
    setViewRatesDataFromAPI([]);
    setUpdatedViewRatesData([]);
    dispatch(clearCostplusData());
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onChangeRatesYear = (val) => {
    setRatesYear(val);
  };

  const onSaveClick = async (data) => {
    setLoading(true);
    setIsSaveClick(true);

    try {
      const directLaborPromise = updateDirectLaborDetailsAPI(
        selectedContract,
        detailedType,
        version,
        data.directLaborCost,
        yearValue,
      );

      const otherCostsPromise = updateOtherDirectCostsDetailsAPI(
        selectedContract,
        detailedType,
        contractYearValue,
        version,
        data.otherDirectCost,
        yearValue,
      );

      const revenuePromise = updateRevenueAPI(
        selectedContract,
        detailedType,
        version,
        data.revenueData,
        yearValue,
      );

      const [directLaborRes, otherCostsRes, revenueRes] = await Promise.all([
        directLaborPromise,
        otherCostsPromise,
        revenuePromise,
      ]);

      const allSuccess =
        directLaborRes?.status === 200 &&
        otherCostsRes?.status === 200 &&
        revenueRes?.status === 200;

      if (allSuccess) {
        setIsSaveClick(false);
        setMsgType("success");
        setMsgText("Data updated successfully");
        setEmptyErrMsg(true);
        await getDetailedViewData();
      } else {
        console.error("Save failed:", {
          directLaborRes,
          otherCostsRes,
          revenueRes,
        });
        setMsgType("error");
        setMsgText("Failed to update data");
      }
    } catch (error) {
      console.error("Unexpected error during save:", error);
      setMsgType("error");
      setMsgText("Unexpected error occurred");
    } finally {
      setIsSaveClick(false);
      setLoading(false);
    }
  };

  const getCostRateValue = (empl_id) => {
    const emp = employees.filter((e) => e.empl_id === empl_id);
    if (emp.length > 0) {
      return emp[0].cost_rate_unloaded;
    }
    return "";
  };

  const onChangeClinSelect = (val, type) => {
    if (type === "clin")
      setClinFormData({
        ...clinFormData,
        lCatId: "",
        lCatDescription: "",
        billRate: 0,
        [type]: val,
      });
    else if (type === "lCatId") {
      setClinFormData({
        ...clinFormData,
        billRate: getLcatIds().filter((item) => item.value === val)[0].billRate,
        [type]: val,
      });
    } else if (type === "employeeSubConId") {
      setClinFormData({
        ...clinFormData,
        costRateUnloaded: getCostRateValue(val),
        [type]: val,
      });
    } else if (type === "employmentTypeId") {
      // "Is IWO?" only ever applies to contractors — switching Employment Type back to
      // Employee unselects it, same as disabling the checkbox does in the Direct Labor table.
      const isEmployee =
        ddlItemName("Employment Type", val).toLowerCase() === "employee";
      setClinFormData({
        ...clinFormData,
        [type]: val,
        isIwo: isEmployee ? false : clinFormData.isIwo,
      });
    } else setClinFormData({ ...clinFormData, [type]: val });
  };

  const onChangeClinIsIwo = (checked) => {
    setClinFormData({
      ...clinFormData,
      isIwo: checked,
      // Same rule as the Direct Labor table's own "Is IWO?" checkbox — checking it forces
      // Apply Burden to "No".
      applyBurden: checked ? false : clinFormData.applyBurden,
    });
  };

  const onValidateNumber = (e) => {
    const changeVal = ["-", ""].includes(e.target.value.trim())
      ? 0
      : e.target.value;
    var validNumber = new RegExp(/^-?[0-9]\d*(\.\d+)?$/);
    if (
      (!validNumber.test(changeVal) && !changeVal.toString().includes(".")) ||
      changeVal.toString().split(".").length - 1 > 1
    )
      return { isValid: false, changeVal: 0 };
    return { isValid: true, changeVal: Number(changeVal) };
  };

  const onChangeSelectODC = (val, type) => {
    setClinFormDataODC({ ...clinFormDataODC, [type]: val });
  };

  const onChangeSelectHeatmap = (value, key) => {
    setHeatMapFormData({ ...heatMapFormData, [key]: value });
  };

  const onChangeHeatmapText = (e, key) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    let newData = { ...heatMapFormData };
    newData.vacantFte = changeVal;
    setHeatMapFormData(newData);
    //setHeatMapFormData({ ...heatMapFormData, [key]: value });
  };

  const onChangeClinText = (value, key) => {
    const changeVal =
      (key === "billRate" ||
        key === "laborEscalation" ||
        key === "costRateUnloaded") &&
      value.trim() === ""
        ? 0
        : value;
    if (
      key === "billRate" ||
      key === "laborEscalation" ||
      key === "costRateUnloaded"
    ) {
      var validNumber = new RegExp(/^-?[0-9]\d*(\.\d+)?$/);
      if (
        (!validNumber.test(changeVal) && !changeVal.toString().includes(".")) ||
        changeVal.toString().split(".").length - 1 > 1
      )
        return false;
    }
    if (
      (key === "billRate" ||
        key === "laborEscalation" ||
        key === "costRateUnloaded") &&
      !changeVal.toString().includes(".")
    )
      setClinFormData({ ...clinFormData, [key]: Number(changeVal) });
    else setClinFormData({ ...clinFormData, [key]: changeVal });
  };
  const toggleDrawerUpload = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenDrawerUpload(open);
  };
  const toggleDrawerUploadPipeline = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenDrawerUploadPipeline(open);
  };

  useEffect(() => {
    if (rmFieldSettingsData && rmFieldSettingsData.status === 200) {
      setRmSettingsData(rmFieldSettingsData.data.fieldSettings);
    }
  }, [rmFieldSettingsData]);

  useEffect(() => {
    if (contractsData && contractsData.status === 200) {
      const bindData = [];
      contractsData.data.forEach((val) => {
        bindData.push({
          value: val.contractId,
          label: val.displayName,
          ...val,
        });
      });
      setContracts(bindData);
    }
  }, [contractsData]);

  useEffect(() => {
    if (
      selectedContract !== "" &&
      version &&
      detailedType !== "" &&
      yearValue !== "" &&
      pageType === "detail"
    ) {
      getProjectClinsAPI(
        selectedContract,
        detailedType,
        version,
        yearValue,
      ).then((res) => {
        setNewClins(res.data.clinDetailsList);
      });
      getClinsForOdcAPI(
        selectedContract,
        detailedType,
        version,
        yearValue,
      ).then((res) => {
        setNewClinsODC(res.data);
      });
    }
  }, [detailedType, selectedContract, version, yearValue]);

  const getYears = (isDefault = false) => {
    const apiCall =
      pageType === "detail"
        ? getFinancialYearOptionsAPI(selectedContract, version, detailedType)
        : getFinancialYearOptionsPSRAPI(selectedContract, version);

    apiCall.then((res) => {
      if (res.status === 200 && res?.data?.listOfFinancialYear) {
        setIsYearAPICalled(false);

        const { listOfFinancialYear, defaultFinancialYear } = res.data;

        const yearsData = listOfFinancialYear.map((val) => ({
          id: val,
          text: val,
        }));

        setFinancialYears(yearsData);

        if (isDefault && defaultFinancialYear) {
          setYearValue(defaultFinancialYear);
        }
      } else {
        setIsYearAPICalled(true);
        setFinancialYears([]);
        setYearValue("");
      }
    });
  };

  useEffect(() => {
    if (selectedContract !== "" && version && detailedType !== "") {
      getYears(true);
    }
  }, [detailedType, selectedContract, version, pageType]);

  useEffect(() => {
    dispatch(getListOfContracts());
    dispatch(getRMFieldSettings());
    getOvertimeTypesAPI().then((res) => {
      if (res.status === 200) {
        setOtTypes(res.data);
      }
    });
    getAddResourceDetailsForContractAPI().then((res) => {
      setNewClinEmployees(res.data);
    });
    resourceListForClinAPI().then((res) => {
      if (res.status === 200) {
        const changedData = JSON.parse(JSON.stringify(res.data));
        const items = [];
        changedData.forEach((emp, i) => {
          if (items.filter((e) => e.empl_id === emp.empl_id).length === 0) {
            items.push(emp);
          }
        });
        setEmployees(items);
      } else if (res.status === 400) {
        setEmployees([]);
      }
    });
  }, []);

  useEffect(() => {
    dispatch(setUnsavedChangesUnnamed(isEdit || isEditFee));
  }, [isEdit, isEditFee]);

  useEffect(() => {
    if (
      updateDetailedRatesData &&
      revenueData.status === 200 &&
      isRatesSaveClick
    ) {
      setLoading(false);
      setMsgType("success");
      setEmptyErrMsg(true);
      setMsgText("Fee rates updated successfully");
      setIsRatesSaveClick(false);
    }
  }, [updateDetailedRatesData]);

  // useEffect(() => {
  //   if (
  //     updatedDirectLaborData.status &&
  //     updatedDirectLaborData.status === 200 &&
  //     updatedOtherCostsData.status &&
  //     updatedOtherCostsData.status === 200 &&
  //     (detailedType !== "FFP" ||
  //       (updatedRevenueData.status && updatedRevenueData.status === 200)) &&
  //     isSaveClick
  //   ) {
  //     // setLoading(false);
  //     setIsSaveClick(false);
  //     setMsgType("success");
  //     setEmptyErrMsg(true);
  //     setMsgText("Data updated successfully");
  //     getDetailedViewData();
  //   }
  // }, [updatedDirectLaborData, updatedOtherCostsData, updatedRevenueData]);

  const udpatedRates = (data) => {
    setIsRatesSaveClick(true);
    setLoading(true);
    dispatch(
      updateDetailedViewRates(
        selectedContract,
        detailedType,
        data,
        yearValue,
        version,
      ),
    );
  };

  useEffect(() => {
    if (
      pageType === "detail" &&
      (detailedType === "Cost Plus" ||
        detailedType === "TM" ||
        detailedType === "FFP")
    ) {
      setViewRatesData([]);
      setViewRatesDataFromAPI([]);
      setUpdatedViewRatesData([]);
      dispatch(clearCostplusData());
      if (version && yearValue !== "") {
        //setLoading(true);
        getDetailedViewData();
      }
    }
    if (pageType === "contract") {
      setLoading(true);
      dispatch(getContractSummary(selectedContract, version, yearValue));
      dispatch(
        getContractSummaryCostPlus(selectedContract, version, yearValue),
      );
      dispatch(
        getContractSummaryEAC(selectedContract, contractYearValue, yearValue),
      );
    }
  }, [
    contractYearValue,
    selectedContract,
    detailedType,
    pageType,
    version,
    yearValue,
  ]);

  useEffect(() => {
    if (pageType === "contract") {
      setLoading(true);
      setHeatMapData([]);
      getHeatMapAPI(selectedContract).then((res) => {
        setLoading(false);
        setHeatMapData(res.data);
      });
    }
  }, [selectedContract, pageType]);

  useEffect(() => {
    if (pageType === "contract" && selectedContract) {
      setClinDetailsData([]);
      getClinLevelDetailsAPI(selectedContract, version).then((res) => {
        setClinDetailsData(res.data);
      });
    }
  }, [selectedContract, pageType, version]);

  useEffect(() => {
    if (pageType === "contract") {
      setLoading(true);
      setAssumptionData();
      if (!version) {
        setLoading(false);
        setAssumptionData({ message: "NO DATA AVAILABLE" });
        return;
      }
      getAssumptionAPI(selectedContract, version).then((res) => {
        setLoading(false);

        if (res.data) {
          setAssumptionData(res.data);
        } else {
          setAssumptionData({ message: res.message });
        }
      });
    }
  }, [selectedContract, pageType, version]);

  useEffect(() => {
    if (
      pageType === "detail" &&
      version &&
      (detailedType === "Cost Plus" ||
        detailedType === "TM" ||
        detailedType === "FFP")
    ) {
      if (yearValue !== "") {
        setLoading(true);
        dispatch(
          getDetailedViewRates(
            selectedContract,
            contractYearValue,
            yearValue,
            version,
          ),
        );
      }
    }
    if (pageType === "psr" || pageType === "weeklyEAC") {
      if (yearValue !== "") {
        setLoading(true);
        dispatch(
          getDetailedViewRates(
            selectedContract,
            contractYearValue,
            yearValue,
            version,
          ),
        );
      }
    }
  }, [selectedContract, detailedType, pageType, yearValue, version]);

  useEffect(() => {
    if (pageType === "weeklyEAC" && selectedContract) {
      getWeeklyEACClinDropdownAPI(selectedContract).then((res) => {
        if (res.status === 200 && res.data && res.data.length > 0) {
          const clinOptions = res.data.map((item) => ({
            value: item.clin,
            label: item.projectName
              ? `${item.clin} — ${item.projectName}`
              : item.clin,
            templateType: item.templateType,
            // Defaults true so CLINs from an older API response (or any
            // response missing the field) keep today's behavior rather than
            // silently losing Edit/Template access.
            isEditable: item.isEditable ?? true,
          }));
          setWeeklyEACClinOptions(clinOptions);
          setWeeklyEACClin(clinOptions[0].value);
        } else {
          setWeeklyEACClinOptions([]);
          setWeeklyEACClin("");
        }
      });
    }
  }, [pageType, selectedContract]);

  const fetchWeeklyEACDirectLabor = () => {
    if (selectedContract && weeklyEACClin && version) {
      setWeeklyEACDirectLaborLoading(true);
      getWeeklyEACDirectLaborAPI(selectedContract, weeklyEACClin, version).then(
        (res) => {
          setWeeklyEACDirectLaborLoading(false);
          if (res.status === 200 && res.data) {
            setWeeklyEACDirectLaborData(res.data);
          } else {
            setWeeklyEACDirectLaborData(null);
          }
        },
      );
    }
  };

  useEffect(() => {
    if (pageType === "weeklyEAC") {
      fetchWeeklyEACDirectLabor();
    }
  }, [pageType, selectedContract, weeklyEACClin, version]);

  // useEffect(() => {
  //   if (selectedContract ) {
  //     dispatch(getDropdownOptions(selectedContract,version));
  //     setDetailedType(defaultTemplate());
  //     dispatch(getListOfVersions(selectedContract));
  //   }
  // }, [selectedContract,version]);
  useEffect(() => {
    if (selectedContract) {
      dispatch(getListOfVersions(selectedContract));
      setDetailedType(defaultTemplate());
      clinForHeatMapAPI(selectedContract).then((res) => {
        setClinsForHeatmap(res.data);
      });
      clinForExtraDetailsAPI(selectedContract).then((res) => {
        setClinsForDetails(res.data);
      });
    }
  }, [selectedContract]);

  // useEffect(() => {
  //   if (selectedContract && version && yearValue !== "") {
  //     dispatch(getDropdownOptions(selectedContract, version, yearValue));
  //   }
  // }, [selectedContract, version, yearValue]);

  useEffect(() => {
    if (
      selectedContract &&
      detailedType &&
      version &&
      detailedType !== "" &&
      yearValue !== "" &&
      pageType === "detail"
    ) {
      dispatch(
        getDetailedViewHeaders(
          selectedContract,
          detailedType,
          version,
          yearValue,
        ),
      );
    }
  }, [selectedContract, detailedType, version, yearValue, pageType]);
  useEffect(() => {
    if (versionsData && versionsData.status === 200) {
      const verData = versionsData.data.map((val) => ({
        id: val.version,
        text: val.versionName,
      }));
      setVersions(verData);
      setVersion(verData[0].id);
    }
    if (versionsData && versionsData.status === 400) {
      setLoading(false);
    }
  }, [versionsData]);
  const getVersionName = () =>
    versions.find((val) => val.id === version)?.text || "";

  const getVersionStatus = () => {
    if (
      version &&
      versionsData.data &&
      versionsData.data.filter((val) => val.version === version).length > 0
    ) {
      return versionsData.data.filter((val) => val.version === version)[0]
        .status;
    }
    return "";
  };

  useEffect(() => {
    if (
      (pageType === "contract" &&
        contractSummaryData &&
        (contractSummaryData.status === 200 ||
          contractSummaryData.status === 400)) ||
      contractSummaryCostPlusData?.status === 200 ||
      contractSummaryCostPlusData?.status === 400 ||
      (pageType === "detail" &&
        (detailedType === "Cost Plus" ||
          detailedType === "TM" ||
          detailedType === "FFP") &&
        directLaborDetailsData &&
        (directLaborDetailsData.status === 200 ||
          directLaborDetailsData.status === 400) &&
        detailedViewRatesData &&
        (detailedViewRatesData.status === 200 ||
          detailedViewRatesData.status === 400) &&
        detailedViewRatesData &&
        detailedViewRatesData.status === 200 &&
        otherDirectCostData &&
        (otherDirectCostData.status === 200 ||
          otherDirectCostData.status === 400) &&
        revenueData &&
        (revenueData.status === 200 || revenueData.status === 400) &&
        marginData &&
        (marginData.status === 200 || marginData.status === 400))
    ) {
      setLoading(false);
    }
  }, [
    contractSummaryData,
    directLaborDetailsData,
    otherDirectCostData,
    revenueData,
    marginData,
    detailedViewHeadersData,
    detailedViewRatesData,
  ]);

  useEffect(() => {
    if (detailedViewHeadersData && detailedViewHeadersData.status === 400) {
      setLoading(false);
    }
  }, [detailedViewHeadersData]);

  const ddlItems = (val) => {
    const items = [];

    const matchingItem = rmSettingsData.find((item) => item.fields === val);
    if (matchingItem) {
      matchingItem.adminPicklistSettingsList
        .filter((pickItem) => pickItem.is_enabled)
        .forEach((finItem) =>
          items.push({ value: finItem.id, label: finItem.name }),
        );
    }

    return items;
  };

  const ddlItemName = (val, id) => {
    let item = "";

    const matchingItem = rmSettingsData.find((item) => item.fields === val);
    if (matchingItem) {
      matchingItem.adminPicklistSettingsList
        .filter((pickItem) => pickItem.is_enabled)
        .forEach((finItem) => {
          if (finItem.id === id) item = finItem.name;
        });
    }

    return item;
  };

  const onDownloadData = () => {
    if (!isEdit) {
      setLoading(true);
      dispatch(
        downloadDetailedView(
          selectedContract,
          detailedType,
          contractYearValue,
          version,
          yearValue,
        ),
      );
      setIsDownloadClick(true);
    }
  };
  const onDownloadPSrData = (clins) => {
    setShowPsrDownloadDialog(false);
    dispatch(downloadPsr(selectedContract, version, clins));
    setIsDownloadPsrClick(true);
  };

  const onDownloadDataPipeline = () => {
    setLoadingPipeline(true);
    downloadOpportunityListAPI(pipelineFilteredOppNos).then((res) => {
      setLoadingPipeline(false);
      if (res.type) {
        downloadFile(res, "pipeline_opportunities");
      }
    });
  };
  const downloadExcel = () => {
    if (!isEdit) {
      setLoading(true);
      downloadDetailedViewTemplateAPI(
        selectedContract,
        detailedType,
        version,
        yearValue,
      ).then((res) => {
        setLoading(false);
        if (res.type) {
          downloadFile(
            res,
            `detailedView_template_${selectedContract}_${detailedType}_${getVersionName()}`,
          );
        }
      });
    }
  };
  const handleOpenWeeklyEACDownloadMenu = (event) => {
    setWeeklyEACDownloadMenuAnchor(event.currentTarget);
  };

  const handleCloseWeeklyEACDownloadMenu = () => {
    setWeeklyEACDownloadMenuAnchor(null);
  };

  const downloadWeeklyEACDirectLabor = () => {
    setWeeklyEACDownloadMenuAnchor(null);
    setWeeklyEACDownloading(true);
    downloadWeeklyEACDirectLaborAPI(
      selectedContract,
      weeklyEACClin,
      version,
    ).then((res) => {
      setWeeklyEACDownloading(false);
      if (res.type) {
        downloadFile(res, `weeklyEAC_${weeklyEACClin}_${getVersionName()}`);
      }
    });
  };

  // One Excel file with the CLIN Summary block of every level-4 CLIN that has Weekly EAC data
  // in yearValue (the screen's own Financial Year selector). See
  // APIIntegrationFiles/WEEKLY_EAC_BULK_CLIN_SUMMARY_FRONTEND_GUIDE.md.
  const downloadWeeklyEACAllClins = () => {
    setWeeklyEACDownloadMenuAnchor(null);
    setWeeklyEACDownloading(true);
    downloadWeeklyEACBulkClinSummaryAPI(
      selectedContract,
      yearValue,
      version,
    ).then((res) => {
      setWeeklyEACDownloading(false);
      if (res?.isFile) {
        downloadFile(
          res.blob,
          `WeeklyEAC_BulkCLINSummary_${selectedContract}_${yearValue}`,
        );
      } else {
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText(
          res?.message ||
            "Unable to download the CLIN summaries. Please try again.",
        );
      }
    });
  };
  const downloadExcelPipeline = () => {};
  const uploadFile = (formData) => {
    setLoading(true);
    uploadDetailedViewAPI(
      selectedContract,
      detailedType,
      version,
      formData,
      yearValue,
    )
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          if (res.type) {
            downloadFile(
              res.blob,
              `uploadedFile_${selectedContract}_${detailedType}`,
            );
          }
          setEmptyErrMsg(true);
          setMsgText("File processed successfully. Please check");
          setOpenDrawerUpload(false);
          setMsgType("success");
          getDetailedViewData();
        }
        if (res.status === 400) {
          setOpenDrawerUpload(false);
          setMsgType("error");
          setEmptyErrMsg(true);
          setMsgText(
            "Unable to process upload file can't open workbook -unsupported file type:UNKNOWN",
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText("Something went wrong during the upload.");
      });
  };

  useEffect(() => {
    if (downloadDetailedViewData.type && isDownloadClick) {
      setLoading(false);
      downloadFile(
        downloadDetailedViewData,
        `detailedView_${selectedContract}_${detailedType}_${getVersionName()}`,
      );
      setIsDownloadClick(false);
    }
  }, [downloadDetailedViewData]);
  useEffect(() => {
    if (downloadpsrData.type && isDownloadPsrClick) {
      downloadFile(
        downloadpsrData,
        `psrtrend_${selectedContract}_${getVersionName()}`,
      );
      setIsDownloadPsrClick(false);
    }
  }, [downloadpsrData]);
  //  useEffect(() => {
  //     if (downloadFinancialExcelData.type && isDownloadExcelClick) {
  //       setLoading(false);
  //       downloadFile(downloadFinancialExcelData, "Details");
  //       setIsDownloadExcelClick(false);
  //     }
  //   }, [downloadFinancialExcelData]);
  //  useEffect(() => {
  //     if (financialExcelData.type && isUploadClick) {
  //       setLoading(false);
  //       setIsUploadClick(false);
  //       setEmptyErrMsg(true);
  //       setMsgText("File processed successfully. Please check");
  //       downloadFile(financialExcelData, "uploadedFile");
  //       setOpenDrawerUpload(false);
  //       setMsgType("success");
  //     }
  //   }, [financialExcelData]);

  useEffect(() => {
    if (
      selectedContract &&
      version &&
      selectedContract !== "" &&
      detailedType !== "" &&
      yearValue !== "" &&
      (pageType === "detail" || pageType === "weeklyEAC")
    ) {
      getViewRates();
    }
  }, [selectedContract, detailedType, version, yearValue, pageType]);

  const handleClickViewRates = () => {
    setShowDialogViewRates(true);
    setTableEditable(false);
  };

  const onUpdateViewRates = () => {
    setLoading(true);
    const dataToUpdate = updatedViewRatesData.map((item) => ({
      ...item,
      feeLabor: Number(isNaN(item.feeLabor) ? 0 : item.feeLabor),
      feeNonLabor: Number(isNaN(item.feeNonLabor) ? 0 : item.feeNonLabor),
      feeSubCon: Number(isNaN(item.feeSubCon) ? 0 : item.feeSubCon),
      isUpdated: true,
    }));
    updateContractClinRatesAPI(dataToUpdate, version, yearValue)
      .then((res) => {
        if (res && (res.status === 200 || res.message === "SUCCESS")) {
          setViewRatesData(deepCopyObject(dataToUpdate));
          setViewRatesDataFromAPI(deepCopyObject(dataToUpdate));
          setTableEditable(false);
          setMsgText("Rates updated successfully");
          setMsgType("success");
          setEmptyErrMsg(true);
          setIsSaveClickUpdateRates(true);
          // setLoading(false);
          //getDetailedViewData();
        }
      })
      .catch((err) => {
        console.error("Error updating rates:", err);
      });
  };

  const onViewRatesInputChange = (index, newValue, fieldName) => {
    const updatedData = deepCopyObject(updatedViewRatesData);
    if (newValue === "") {
      updatedData[index][fieldName] = 0;
    } else if (!isNaN(newValue)) {
      updatedData[index][fieldName] = parseFloat(newValue);
    }
    setUpdatedViewRatesData(updatedData);
    setViewRatesData(updatedData);
  };

  const onCloseViewRates = () => {
    setShowDialogViewRates(false);
    setTableEditable(false);
    setUpdatedViewRatesData(deepCopyObject(viewRatesDataFromAPI));
    setViewRatesData(deepCopyObject(viewRatesDataFromAPI));
  };

  const onCancelViewRatesEditable = () => {
    setTableEditable(false);
    const originalCopy = deepCopyObject(viewRatesDataFromAPI);
    setUpdatedViewRatesData(originalCopy);
    setViewRatesData(deepCopyObject(viewRatesDataFromAPI));
  };

  const onClickDirectLaborDetails = (item) => {
    setIsEditDetails(true);
    setSelectedDirectLabor({
      dlId: item.dlId,
      templateType: detailedType,
      contractId: selectedContract,
    });
    setClinFormData({
      ...clinFormData,
      notes: item.notes,
    });
    setShowDialogNew(true);
  };

  const weeklyEACSelectedClinOption = weeklyEACClinOptions.find(
    (option) => option.value === weeklyEACClin,
  );
  const weeklyEACType = weeklyEACSelectedClinOption?.templateType || "";
  const weeklyEACIsEditable = weeklyEACSelectedClinOption?.isEditable ?? true;

  return (
    <div className={classes.componentStyles}>
      <Box display="flex" flexDirection="row">
        <Box style={{ paddingTop: "24px" }}>
          <FormControl
            component="fieldset"
            className="financialRadio"
            style={{ margin: "4px 0 0 0" }}
          >
            <RadioGroup
              aria-label="sectionItem"
              name="sectionItem"
              value={sectionType}
              onChange={(e) => setSectionType(e.target.value)}
              row
            >
              {modules.includes("Contract") && (
                <FormControlLabel
                  className={
                    sectionType === "Contract" && classes.selectedLabel
                  }
                  value="Contract"
                  control={<Radio color="primary" />}
                  label="Contract"
                />
              )}
              {modules.includes("Indirect") && (
                <FormControlLabel
                  className={
                    sectionType === "Indirect" && classes.selectedLabel
                  }
                  value="Indirect"
                  control={<Radio color="primary" />}
                  label="Indirect"
                />
              )}
              {modules.includes("Fringe") && (
                <FormControlLabel
                  className={sectionType === "Fringe" && classes.selectedLabel}
                  value="Fringe"
                  control={<Radio color="primary" />}
                  label="Fringe"
                />
              )}
              {(modules.includes("Pipeline") ||
                localStorage.getItem("email").includes("nextq.ai")) && (
                <FormControlLabel
                  className={
                    sectionType === "Pipeline" && classes.selectedLabel
                  }
                  value="Pipeline"
                  control={<Radio color="primary" />}
                  label="Pipeline"
                />
              )}
            </RadioGroup>
          </FormControl>
        </Box>
        {sectionType === "Contract" && (
          <>
            <Box>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  marginBottom: "4px",
                }}
              >
                Select Contract
              </div>
              <Select
                showSearch
                mode="single"
                style={{ width: "250px", zIndex: 9, marginBottom: "12px" }}
                placeholder="Search to Select"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={contracts}
                onChange={(val) => onChangeContract(val)}
                value={selectedContract}
              />
            </Box>
            {pageType === "weeklyEAC" && (
              <Box style={{ marginLeft: "20px" }}>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    marginBottom: "4px",
                  }}
                >
                  Select CLIN
                </div>
                <Select
                  showSearch
                  mode="single"
                  style={{ width: "300px", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={weeklyEACClinOptions}
                  onChange={(val) => setWeeklyEACClin(val)}
                  value={weeklyEACClin}
                />
              </Box>
            )}
            {selectedContract && selectedContract !== "" && (
              <Box style={{ marginLeft: "20px", marginTop: "28px" }}>
                <span style={{ fontWeight: 600, fontSize: "13px" }}>
                  PC Name:
                </span>
                <span style={{ fontSize: "13px", marginLeft: "4px" }}>
                  {contracts.filter(
                    (val) => val.contractId === selectedContract,
                  ).length > 0
                    ? contracts.filter(
                        (val) => val.contractId === selectedContract,
                      )[0].projectController || ""
                    : ""}
                </span>
              </Box>
            )}
          </>
        )}
        {/* {sectionType === "Pipeline" && (
          <Box>
            <div
              style={{ fontSize: "14px", fontWeight: 600, marginBottom: "4px" }}
            >
              Select Opportunity
            </div>
            <Select
              showSearch
              mode="single"
              style={{ width: "250px", zIndex: 9, marginBottom: "12px" }}
              placeholder="Search to Select"
              showArrow
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label.toLowerCase() ?? "").includes(
                  input.toLowerCase()
                )
              }
              options={opportunities}
              onChange={(val) => onChangeOpportunity(val)}
              value={selectedOpportunity}
            />
          </Box>
        )} */}
      </Box>

      {sectionType === "Contract" &&
        selectedContract &&
        selectedContract !== "" && (
          <>
            <Paper className={classes.tabPaper}>
              <Grid container spacing={2} style={{}}>
                <Grid item lg={6} style={{ paddingTop: "10px" }}>
                  <ToggleButtonGroup
                    style={{}}
                    className="financialToggle"
                    value={pageType}
                    exclusive
                    onChange={(event, value) => {
                      handleChangePageType(value);
                    }}
                  >
                    <ToggleButton
                      value="contract"
                      style={{ textTransform: "none" }}
                    >
                      Contract Summary
                    </ToggleButton>
                    <ToggleButton value="psr" style={{ textTransform: "none" }}>
                      PSR Trend
                    </ToggleButton>
                    <ToggleButton
                      value="detail"
                      style={{ textTransform: "none" }}
                    >
                      Detailed View
                    </ToggleButton>
                    {hadTemplate("weeklyEacEnabled") && (
                      <ToggleButton
                        value="weeklyEAC"
                        style={{ textTransform: "none" }}
                      >
                        Weekly EAC
                      </ToggleButton>
                    )}
                  </ToggleButtonGroup>
                  {pageType === "detail" && (
                    <FormControl
                      component="fieldset"
                      className="financialRadio"
                      style={{ margin: "4px 0 0 32px" }}
                    >
                      <RadioGroup
                        aria-label="frequencyItem"
                        name="frequencyItem"
                        value={detailedType}
                        onChange={handleChangeDetailedType}
                        row
                      >
                        {hadTemplate("showCostPlus") && (
                          <FormControlLabel
                            className={
                              detailedType === "Cost Plus" &&
                              classes.selectedLabel
                            }
                            value="Cost Plus"
                            control={<Radio color="primary" />}
                            label="Cost Plus"
                          />
                        )}
                        {hadTemplate("showTM") && (
                          <FormControlLabel
                            className={
                              detailedType === "TM" && classes.selectedLabel
                            }
                            value="TM"
                            control={<Radio color="primary" />}
                            label="T&M"
                          />
                        )}
                        {hadTemplate("showFFP") && (
                          <FormControlLabel
                            className={
                              detailedType === "FFP" && classes.selectedLabel
                            }
                            value="FFP"
                            control={<Radio color="primary" />}
                            label="FFP"
                          />
                        )}
                      </RadioGroup>
                    </FormControl>
                  )}
                </Grid>
                <Grid item lg={6} style={{ position: "relative" }}>
                  <div className={classes.icons}>
                    {pageType === "detail" &&
                      getVersionStatus().toLowerCase() === "open" &&
                      localStorage.getItem("accessType") === "R" && (
                        <span
                          style={{
                            cursor: isEdit ? "default" : "pointer",
                            position: "absolute",
                            right: "36px",
                            top: "12px",
                          }}
                          onClick={() => downloadExcel()}
                          title={!isEdit ? "Download Template" : ""}
                        >
                          <DownloadTemplateIcon
                            color={isEdit ? "#ccc" : "#0070D2"}
                          />
                        </span>
                      )}
                    {pageType === "detail" &&
                      getVersionStatus().toLowerCase() === "open" &&
                      localStorage.getItem("accessType") === "RW" && (
                        <>
                          <span
                            style={{
                              cursor: isEdit ? "default" : "pointer",
                              position: "absolute",
                              right: "72px",
                              top: "12px",
                            }}
                            onClick={() => downloadExcel()}
                            title={!isEdit ? "Download Template" : ""}
                          >
                            <DownloadTemplateIcon
                              color={isEdit ? "#ccc" : "#0070D2"}
                            />
                          </span>
                          <span
                            style={{
                              cursor: isEdit ? "default" : "pointer",
                              position: "absolute",
                              right: "36px",
                              top: "4px",
                            }}
                            onClick={toggleDrawerUpload(!isEdit)}
                            title={!isEdit ? "Upload" : ""}
                          >
                            {" "}
                            <UploadIcon
                              background={isEdit ? "#ccc" : "#0070D2"}
                              color="#fff"
                            />
                          </span>

                          <Drawer
                            anchor="right"
                            open={openDrawerUpload}
                            onClose={toggleDrawerUpload(false)}
                          >
                            <div className={classes.drawerDataSection}>
                              <div className={classes.drawerTitle}>
                                Bulk Upload
                              </div>
                              <div className={classes.uploadDescription}>
                                Please Drag and Drop or select the required
                                files
                              </div>
                              <div
                                className={classes.closeSection}
                                onClick={toggleDrawerUpload(false)}
                              >
                                <CloseIcon className={classes.closeIcon} />
                              </div>
                              <FileUpload getFormData={uploadFile} />
                            </div>
                          </Drawer>
                        </>
                      )}

                    {pageType === "detail" && (
                      <span
                        style={{
                          cursor: isEdit ? "default" : "pointer",
                          position: "absolute",
                          right: "0",
                          top: "4px",
                        }}
                        title={!isEdit ? "Download" : ""}
                        onClick={onDownloadData}
                      >
                        <DownloadIcon
                          background={isEdit ? "#ccc" : "#0070D2"}
                          color="#fff"
                        />
                      </span>
                    )}

                    {pageType === "psr" && (
                      <span
                        style={{
                          cursor: "pointer",
                          float: "right",
                          marginTop: "-4px",
                        }}
                        title={"Download"}
                        onClick={() => setShowPsrDownloadDialog(true)}
                      >
                        <DownloadIcon background={"#0070D2"} color="#fff" />
                      </span>
                    )}

                    {pageType === "weeklyEAC" && (
                      <>
                        <WeeklyEACTemplateActions
                          contractId={selectedContract}
                          clin={weeklyEACClin}
                          version={version}
                          versionName={getVersionName()}
                          versionStatus={getVersionStatus()}
                          accessType={localStorage.getItem("accessType")}
                          isEditable={weeklyEACIsEditable}
                          onUploaded={fetchWeeklyEACDirectLabor}
                        />
                        <span
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            right: "0",
                            top: "4px",
                          }}
                          title={"Download"}
                          onClick={handleOpenWeeklyEACDownloadMenu}
                        >
                          <DownloadIcon background={"#0070D2"} color="#fff" />
                        </span>
                        <Menu
                          anchorEl={weeklyEACDownloadMenuAnchor}
                          open={Boolean(weeklyEACDownloadMenuAnchor)}
                          onClose={handleCloseWeeklyEACDownloadMenu}
                          getContentAnchorEl={null}
                          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                          transformOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                          <MenuItem onClick={downloadWeeklyEACDirectLabor}>
                            Current CLIN
                          </MenuItem>
                          <MenuItem onClick={downloadWeeklyEACAllClins}>
                            All CLINs
                          </MenuItem>
                        </Menu>
                      </>
                    )}
                  </div>

                  <>
                    {version && (
                      <>
                        {" "}
                        {pageType !== "contract" && (
                          <>
                            <div
                              className="clearfix"
                              style={{
                                float: "right",
                                marginRight:
                                  pageType === "weeklyEAC" &&
                                  !weeklyEACIsEditable
                                    ? "28px"
                                    : (pageType === "detail" ||
                                          pageType === "weeklyEAC") &&
                                        getVersionStatus().toLowerCase() ===
                                          "open"
                                      ? localStorage.getItem("accessType") ===
                                        "RW"
                                        ? "102px"
                                        : "60px"
                                      : (pageType === "detail" ||
                                            pageType === "weeklyEAC") &&
                                          getVersionStatus().toLowerCase() !==
                                            "open"
                                        ? "28px"
                                        : "0px",
                                //marginRight: "32px",
                                marginTop: "2px",
                              }}
                            >
                              <CustomSelect
                                selectedValue={yearValue}
                                onChangeItem={(e) =>
                                  onChangeYear(e.target.value)
                                }
                                labelVal="Year"
                                id="Year"
                                items={financialYears}
                                width="120px"
                                borderColor="#000"
                              />
                            </div>
                            <div
                              style={{
                                float: "right",
                                margin: "6px  8px 0 0",
                                fontWeight: 600,
                              }}
                            >
                              Financial Year
                            </div>
                          </>
                        )}
                        <div
                          className="clearfix"
                          style={{
                            float: "right",
                            marginRight: pageType !== "contract" ? "12px" : 0,
                            //marginRight: "32px",
                            marginTop: "2px",
                          }}
                        >
                          <CustomSelect
                            selectedValue={version}
                            onChangeItem={(e) => setVersion(e.target.value)}
                            labelVal="Version"
                            id="version"
                            items={versions}
                            width="120px"
                            borderColor="#000"
                          />
                        </div>
                        <div
                          style={{
                            float: "right",
                            margin: "6px  8px 0 0",
                            fontWeight: 600,
                          }}
                        >
                          Version
                        </div>
                      </>
                    )}
                  </>
                </Grid>
              </Grid>
            </Paper>
            {pageType === "contract" && (
              <ContractSummaryTab
                heatMapData={heatMapData}
                selectedContract={selectedContract}
                version={version}
                assumptionData={assumptionData}
                getVersionStatus={getVersionStatus()}
                clins={clinsForDetails}
                clinDetailsData={clinDetailsData}
                showAddHeatMap={(val) => {
                  setShowAddHeatMap(val);
                  setHeatMapFormData(defaultNewHeatmap);
                }}
              />
            )}
            {pageType === "detail" &&
              (detailedType === "Cost Plus" ||
                detailedType === "TM" ||
                detailedType === "FFP") &&
              !isYearAPICalled &&
              detailedViewRatesData &&
              detailedViewRatesData.data &&
              detailedViewRatesData.data.gAndA && (
                <CostPlus
                  detailedType={detailedType}
                  changedAPIData={onSaveClick}
                  udpatedRates={udpatedRates}
                  viewRatesData={viewRatesData}
                  changedRatesYear={onChangeRatesYear}
                  contractYearValue={contractYearValue}
                  version={version}
                  isEdit={isEdit}
                  isEditFee={isEditFee}
                  setIsEdit={setIsEdit}
                  setIsEditFee={setIsEditFee}
                  handleAddNewDirectLabor={() => handleAddNewDirectLabor()}
                  handleClickViewRates={() => handleClickViewRates()}
                  handleAddNewODC={() => handleAddNewODC()}
                  isSaveClickUpdateRates={isSaveClickUpdateRates}
                  updateIsSaveClickUpdateRates={(val) =>
                    setIsSaveClickUpdateRates(val)
                  }
                  onClickDirectLaborDetails={onClickDirectLaborDetails}
                  contractId={selectedContract}
                  updateClinReviseDate={updateClinReviseDate}
                  getVersionStatus={getVersionStatus()}
                  yearValue={yearValue}
                  otTypes={otTypes}
                />
              )}
            {pageType === "psr" && yearValue !== "" && (
              <PSRTrend
                contractId={selectedContract}
                version={version}
                yearValue={yearValue}
              />
            )}
            {pageType === "weeklyEAC" && (
              <WeeklyEACs
                contractId={selectedContract}
                clin={weeklyEACClin}
                version={version}
                type={weeklyEACType}
                isEditable={weeklyEACIsEditable}
                directLaborData={weeklyEACDirectLaborData}
                loading={weeklyEACDirectLaborLoading}
                onSaved={fetchWeeklyEACDirectLabor}
                detailedViewRatesData={detailedViewRatesData}
                handleClickViewRates={() => handleClickViewRates()}
              />
            )}
          </>
        )}
      {sectionType === "Pipeline" &&
        selectedOpportunity &&
        selectedOpportunity !== "" && (
          <>
            <Paper
              className={classes.tabPaper}
              style={{ marginTop: "16px", minHeight: "56px" }}
            >
              <Grid container spacing={2} style={{}}>
                <Grid item lg={6} style={{ paddingTop: "10px" }}></Grid>
                <Grid item lg={6} style={{ position: "relative" }}>
                  <div className={classes.icons}>
                    {/* <span
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "72px",
                        top: "10px",
                      }}
                      onClick={() => downloadExcelPipeline()}
                      title={"Download Template"}
                    >
                      <DownloadTemplateIcon color={"#0070D2"} />
                    </span>
                    <span
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "36px",
                        top: "2px",
                      }}
                      onClick={toggleDrawerUploadPipeline()}
                      title={"Upload"}
                    >
                      {" "}
                      <UploadIcon background={"#0070D2"} color="#fff" />
                    </span> */}
                    <span
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "0",
                        top: "2px",
                      }}
                      title={"Download"}
                      onClick={onDownloadDataPipeline}
                    >
                      <DownloadIcon background={"#0070D2"} color="#fff" />
                    </span>
                  </div>
                  {showPipelineFinancialYear && (
                    <>
                      <div
                        className="clearfix"
                        style={{
                          float: "right",
                          marginRight: "0px",
                          //marginRight: "100px",
                        }}
                      >
                        <CustomSelect
                          selectedValue={yearValuePipeline}
                          onChangeItem={(e) =>
                            onChangeYearPipeline(e.target.value)
                          }
                          labelVal="Year"
                          id="YearPipeline"
                          items={financialYearsPipeline}
                          width="120px"
                          borderColor="#000"
                        />
                      </div>
                      <div
                        style={{
                          float: "right",
                          margin: "6px  8px 0 0",
                          fontWeight: 600,
                        }}
                      >
                        Financial Year
                      </div>
                    </>
                  )}
                </Grid>
              </Grid>
            </Paper>
            {plData && (
              <Pipeline
                PLData={plData}
                isAddOpp={isAddOpp}
                setIsAddOpp={(val) => setIsAddOpp(val)}
                showOpportunityDetails={(val) =>
                  setShowPipelineFinancialYear(val)
                }
                onFilteredOppNosChange={(val) =>
                  setPipelineFilteredOppNos(val)
                }
              />
            )}
          </>
        )}
      {sectionType === "Indirect" && (
        <IndirectSummaryTab isEdit={isEdit} setIsEdit={setIsEdit} />
      )}
      {sectionType === "Fringe" && (
        <Fringe isEdit={isEdit} setIsEdit={setIsEdit} />
      )}
      {versionsData?.status === 200 &&
        !isYearAPICalled &&
        pageType === "detail" &&
        (loading ||
          loadingAPI ||
          directLaborDetailsData?.loading ||
          otherDirectCostData?.loading ||
          revenueData?.loading) && <Loading />}
      {pageType === "psr" && isDownloadPsrClick && loadingAPI && <Loading />}
      <PsrDownloadDialog
        open={showPsrDownloadDialog}
        contractId={selectedContract}
        onClose={() => setShowPsrDownloadDialog(false)}
        onDownload={onDownloadPSrData}
      />
      {loadingHeatmap && <Loading />}
      {loadingPipeline && <Loading />}
      {weeklyEACDownloading && <Loading />}
      {showDialogNew && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="lg"
          aria-labelledby="confirmation-dialog"
          open={showDialogNew}
        >
          <DialogContent className={classes.addDialog}>
            <div className={classes.popupHeader}>
              <span
                className={classes.closeIconAdd}
                onClick={() => {
                  setShowDialogNew(false);
                  setIsEditDetails(false);
                }}
              >
                x
              </span>
              <div className={classes.addColumnTitle}>
                {isEditDetails ? `Notes` : `Add New Resource`}
              </div>
            </div>
            <Grid container spacing={2}>
              {!isEditDetails && (
                <>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>
                      Select CLIN
                      <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                    </div>

                    <Select
                      showSearch
                      mode="single"
                      style={{ width: "95%", zIndex: 9 }}
                      placeholder="Search to Select"
                      showArrow
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label.toLowerCase() ?? "").includes(
                          input.toLowerCase(),
                        )
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={newClins.map((val) => ({
                        value: val.clin,
                        label: val.clin,
                      }))}
                      onChange={(val) => onChangeClinSelect(val, "clin")}
                      value={clinFormData.clin}
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>
                      Employment Type
                      <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                    </div>
                    <Select
                      showSearch
                      mode="single"
                      style={{ width: "95%", zIndex: 9 }}
                      placeholder="Search to Select"
                      showArrow
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label.toLowerCase() ?? "").includes(
                          input.toLowerCase(),
                        )
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={ddlItems("Employment Type")}
                      onChange={(val) =>
                        onChangeClinSelect(val, "employmentTypeId")
                      }
                      value={clinFormData.employmentTypeId}
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>Is IWO?</div>
                    <input
                      type="checkbox"
                      checked={clinFormData.isIwo}
                      disabled={
                        clinFormData.employmentTypeId === "" ||
                        ddlItemName(
                          "Employment Type",
                          clinFormData.employmentTypeId,
                        ).toLowerCase() === "employee"
                      }
                      onChange={(e) => onChangeClinIsIwo(e.target.checked)}
                    />
                  </Grid>
                  {clinFormData.clin && getLcatIds().length === 0 ? (
                    <>
                      <Grid item lg={6}>
                        <div className={classes.fieldTitle}>LCAT Id</div>
                        <CustomTextField
                          selectedValue={clinFormData.lCatId}
                          onChangeItem={(e) =>
                            onChangeClinText(e.target.value, "lCatId")
                          }
                          id="lCatId"
                          itemWidth="95%"
                        />
                      </Grid>
                      <Grid item lg={6}>
                        <div className={classes.fieldTitle}>
                          LCAT Description
                        </div>
                        <CustomTextField
                          selectedValue={clinFormData.lCatDescription}
                          onChangeItem={(e) =>
                            onChangeClinText(e.target.value, "lCatDescription")
                          }
                          id="lCatDescription"
                          itemWidth="95%"
                        />
                      </Grid>
                    </>
                  ) : (
                    <Grid item lg={6}>
                      <div className={classes.fieldTitle}>
                        Select LCAT
                        {getLcatIds().length > 0 && (
                          <span style={{ color: "red", marginLeft: "4px" }}>
                            *
                          </span>
                        )}
                      </div>
                      <Select
                        showSearch
                        mode="single"
                        style={{ width: "95%", zIndex: 9 }}
                        placeholder="Search to Select"
                        showArrow
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label.toLowerCase() ?? "").includes(
                            input.toLowerCase(),
                          )
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? "")
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? "").toLowerCase())
                        }
                        options={getLcatIds()}
                        onChange={(val) => onChangeClinSelect(val, "lCatId")}
                        value={clinFormData.lCatId}
                      />
                    </Grid>
                  )}
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>Select Employee</div>
                    <Select
                      showSearch
                      mode="single"
                      style={{ width: "95%", zIndex: 9 }}
                      placeholder="Search to Select"
                      showArrow
                      allowClear={true}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label.toLowerCase() ?? "").includes(
                          input.toLowerCase(),
                        )
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={getEmployees()}
                      onChange={(val) =>
                        onChangeClinSelect(val, "employeeSubConId")
                      }
                      value={clinFormData.employeeSubConId}
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>NOTE</div>
                    <CustomTextField
                      selectedValue={clinFormData.pOLine}
                      onChangeItem={(e) =>
                        onChangeClinText(e.target.value, "pOLine")
                      }
                      id="pOLine"
                      itemWidth="95%"
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>
                      Cost Rate (Unloaded)
                      <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                    </div>
                    <CustomTextField
                      selectedValue={clinFormData.costRateUnloaded}
                      onChangeItem={(e) =>
                        onChangeClinText(e.target.value, "costRateUnloaded")
                      }
                      id="costRateUnloaded"
                      itemWidth="95%"
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>PN</div>
                    <CustomTextField
                      selectedValue={clinFormData.pn}
                      onChangeItem={(e) =>
                        onChangeClinText(e.target.value, "pn")
                      }
                      id="pn"
                      itemWidth="95%"
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>
                      {" "}
                      Labor Escalation %
                    </div>
                    <CustomTextField
                      selectedValue={clinFormData.laborEscalation}
                      onChangeItem={(e) =>
                        onChangeClinText(e.target.value, "laborEscalation")
                      }
                      id="laborEscalation"
                      itemWidth="95%"
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>
                      {detailedType === "TM"
                        ? "Adjusted Bill Rate"
                        : "Bid Rate"}
                    </div>
                    <CustomTextField
                      selectedValue={clinFormData.billRate}
                      onChangeItem={(e) =>
                        onChangeClinText(e.target.value, "billRate")
                      }
                      id="billRate"
                      itemWidth="95%"
                      disabled={
                        !(clinFormData.clin && getLcatIds().length === 0)
                      }
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <div className={classes.fieldTitle}>
                      Apply Burden{" "}
                      <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                    </div>
                    <Select
                      showSearch
                      mode="single"
                      style={{ width: "95%", zIndex: 9 }}
                      placeholder="Search to Select"
                      showArrow
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label.toLowerCase() ?? "").includes(
                          input.toLowerCase(),
                        )
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={yesNoDdl}
                      onChange={(val) => onChangeClinSelect(val, "applyBurden")}
                      value={clinFormData.applyBurden}
                      disabled={clinFormData.isIwo}
                    />
                  </Grid>
                </>
              )}

              <Grid item lg={12}>
                {!isEditDetails && (
                  <div className={classes.fieldTitle}>
                    Notes
                    <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                  </div>
                )}

                <TextArea
                  rows={6}
                  placeholder="Notes"
                  maxLength={256}
                  value={clinFormData.notes}
                  onChange={(e) => {
                    setClinFormData({
                      ...clinFormData,
                      notes: e.target.value,
                    });
                  }}
                />
              </Grid>
            </Grid>

            <div className={classes.popupBtnsAdd}>
              <Button
                className={classes.saveBtn}
                variant="contained"
                color="primary"
                onClick={() => onAddDirectLabor()}
                disabled={
                  (!isEditDetails &&
                    (clinFormData.clin === "" ||
                      clinFormData.employmentTypeId === "" ||
                      (clinFormData.lCatId === "" && getLcatIds().length > 0) ||
                      clinFormData.costRateUnloaded === 0 ||
                      ((!clinFormData.notes || clinFormData.notes === "") &&
                        (!clinFormData.employeeSubConId ||
                          clinFormData.employeeSubConId === "")))) ||
                  (isEditDetails &&
                    (!clinFormData.notes || clinFormData.notes === ""))
                }
              >
                Add
              </Button>
              <Button
                variant="outlined"
                className={classes.cancelBtnPopup}
                color="primary"
                onClick={() => {
                  setShowDialogNew(false);
                  setIsEditDetails(false);
                }}
              >
                Cancel
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
      {showAddHeatMap && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="lg"
          aria-labelledby="confirmation-dialog"
          open={showAddHeatMap}
        >
          <DialogContent className={classes.addDialogHeatmap}>
            <div className={classes.popupHeader}>
              <span
                className={classes.closeIconAdd}
                onClick={() => setShowAddHeatMap(false)}
              >
                x
              </span>
              <div className={classes.addColumnTitle}>Add New</div>
            </div>
            <Grid container>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Select CLIN
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>

                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={clinsForHeatmap.map((val) => ({
                    value: val,
                    label: val,
                  }))}
                  onChange={(val) => onChangeSelectHeatmap(val, "clin")}
                  value={heatMapFormData.clin}
                />
              </Grid>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Financial
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>

                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={heatMapColors}
                  onChange={(val) => onChangeSelectHeatmap(val, "financial")}
                  value={heatMapFormData.financial}
                />
              </Grid>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Perform
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>

                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={heatMapColors}
                  onChange={(val) => onChangeSelectHeatmap(val, "perform")}
                  value={heatMapFormData.perform}
                />
              </Grid>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Funding
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>

                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={heatMapColors}
                  onChange={(val) => onChangeSelectHeatmap(val, "funding")}
                  value={heatMapFormData.funding}
                />
              </Grid>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Staffing
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>

                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={heatMapColors}
                  onChange={(val) => onChangeSelectHeatmap(val, "staffing")}
                  value={heatMapFormData.staffing}
                />
              </Grid>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Culture
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>

                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={heatMapColors}
                  onChange={(val) => onChangeSelectHeatmap(val, "culture")}
                  value={heatMapFormData.culture}
                />
              </Grid>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Customer
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>

                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={heatMapColors}
                  onChange={(val) => onChangeSelectHeatmap(val, "customer")}
                  value={heatMapFormData.customer}
                />
              </Grid>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  Doge
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>

                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={heatMapColors}
                  onChange={(val) => onChangeSelectHeatmap(val, "doge")}
                  value={heatMapFormData.doge}
                />
              </Grid>
              <Grid item lg={6}>
                <div className={classes.fieldTitle}>
                  No of Vacant FTE{" "}
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>
                <CustomTextField
                  selectedValue={heatMapFormData.vacantFte}
                  onChangeItem={(e) => onChangeHeatmapText(e, "vacantFte")}
                  id="vacantFte"
                  itemWidth="95%"
                />
              </Grid>
            </Grid>

            <div className={classes.popupBtnsAdd}>
              <Button
                className={classes.saveBtn}
                variant="contained"
                color="primary"
                onClick={() => onAddHeatmap()}
                disabled={
                  heatMapFormData.clin === "" ||
                  heatMapFormData.culture === "" ||
                  heatMapFormData.customer === "" ||
                  heatMapFormData.doge === "" ||
                  heatMapFormData.financial === "" ||
                  heatMapFormData.funding === "" ||
                  heatMapFormData.perform === "" ||
                  heatMapFormData.staffing === "" ||
                  heatMapFormData.vacantFte === ""
                }
              >
                Add
              </Button>
              <Button
                variant="outlined"
                className={classes.cancelBtnPopup}
                color="primary"
                onClick={() => setShowAddHeatMap(false)}
              >
                Cancel
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
      {showDialogODC && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="lg"
          aria-labelledby="confirmation-dialog"
          open={showDialogODC}
        >
          <DialogContent className={classes.addDialogODC}>
            <div className={classes.popupHeader}>
              <span
                className={classes.closeIconAdd}
                onClick={() => setShowDialogODC(false)}
              >
                x
              </span>
              <div className={classes.addColumnTitle}>Add New ODC</div>
            </div>
            <Grid container>
              <Grid item lg={12}>
                <div className={classes.fieldTitle}>
                  Select CLIN
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>

                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={newClinsODC.map((val) => ({
                    value: val,
                    label: val,
                  }))}
                  onChange={(val) => onChangeSelectODC(val, "clin")}
                  value={clinFormDataODC.clin}
                />
              </Grid>
              <Grid item lg={12}>
                <div className={classes.fieldTitle}>
                  Expense Type
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>
                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={expenseTypes}
                  onChange={(val) => onChangeSelectODC(val, "expenseType")}
                  value={clinFormDataODC.expenseType}
                />
              </Grid>
              <Grid item lg={12}>
                <div className={classes.fieldTitle}>
                  Apply Burden
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </div>
                <Select
                  showSearch
                  mode="single"
                  style={{ width: "95%", zIndex: 9, marginBottom: "12px" }}
                  placeholder="Search to Select"
                  showArrow
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label.toLowerCase() ?? "").includes(
                      input.toLowerCase(),
                    )
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={yesNoDdl}
                  onChange={(val) => onChangeSelectODC(val, "applyBurden")}
                  value={clinFormDataODC.applyBurden}
                />
              </Grid>
            </Grid>

            <div className={classes.popupBtnsAdd}>
              <Button
                className={classes.saveBtn}
                variant="contained"
                color="primary"
                onClick={() => onAddODC()}
                disabled={
                  clinFormDataODC.clin === "" ||
                  clinFormDataODC.expenseType === "" ||
                  clinFormDataODC.applyBurden === ""
                }
              >
                Add
              </Button>
              <Button
                variant="outlined"
                className={classes.cancelBtnPopup}
                color="primary"
                onClick={() => setShowDialogODC(false)}
              >
                Cancel
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
      {showDialogViewRates && (
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="lg"
          aria-labelledby="confirmation-dialog"
          open={showDialogViewRates}
        >
          <DialogContent className={classes.addDialog}>
            <div className={classes.popupHeader}>
              <span className={classes.closeIconAdd} onClick={onCloseViewRates}>
                x
              </span>
              <div className={classes.addColumnTitle}>View Rates</div>
            </div>
            {tableEditable ? (
              <div className={classes.viewRatePopupBtn}>
                <span className={classes.updateBtn} onClick={onUpdateViewRates}>
                  {" "}
                  Update{" "}
                </span>
                <span
                  className={classes.cancelBtn}
                  onClick={onCancelViewRatesEditable}
                >
                  {" "}
                  Cancel{" "}
                </span>
              </div>
            ) : getVersionStatus().toLowerCase() === "open" &&
              localStorage.getItem("accessType") === "RW" ? (
              <div className={classes.viewRatePopupBtn}>
                <div
                  className={classes.editBtn}
                  onClick={() => setTableEditable(true)}
                >
                  <EditIcon className={classes.editIcon} />
                  <span className={classes.editText}> Edit </span>
                </div>
              </div>
            ) : (
              ""
            )}
            <table className={classes.table}>
              <thead>
                <tr className={classes.tableHeader}>
                  <th className={classes.tableCell}>
                    <strong>CLIN</strong>
                  </th>
                  <th className={classes.tableCell}>
                    <strong>Fee - Labor</strong>
                  </th>
                  <th className={classes.tableCell}>
                    <strong>Fee - Non Labor</strong>
                  </th>
                  <th className={classes.tableCell}>
                    <strong>Fee - Sub Con</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {updatedViewRatesData.map((row, i) => (
                  <tr
                    key={i}
                    className={
                      i % 2 === 0 ? classes.zebraRow : classes.zebraRowDark
                    }
                  >
                    <td className={classes.tableCell}>{row.clin}</td>
                    <td className={classes.tableCell}>
                      {tableEditable ? (
                        <input
                          onChange={(e) =>
                            onViewRatesInputChange(
                              i,
                              e.target.value,
                              "feeLabor",
                            )
                          }
                          className={classes.tableCellInput}
                          value={isNaN(row.feeLabor) ? 0 : row.feeLabor}
                          type="number"
                        />
                      ) : (
                        `${isNaN(row.feeLabor) ? 0 : row.feeLabor}%`
                      )}
                    </td>
                    <td className={classes.tableCell}>
                      {tableEditable ? (
                        <input
                          onChange={(e) =>
                            onViewRatesInputChange(
                              i,
                              e.target.value,
                              "feeNonLabor",
                            )
                          }
                          className={classes.tableCellInput}
                          value={isNaN(row.feeNonLabor) ? 0 : row.feeNonLabor}
                          type="number"
                        />
                      ) : (
                        `${isNaN(row.feeNonLabor) ? 0 : row.feeNonLabor}%`
                      )}
                    </td>
                    <td className={classes.tableCell}>
                      {tableEditable ? (
                        <input
                          onChange={(e) =>
                            onViewRatesInputChange(
                              i,
                              e.target.value,
                              "feeSubCon",
                            )
                          }
                          className={classes.tableCellInput}
                          value={isNaN(row.feeSubCon) ? 0 : row.feeSubCon}
                          type="number"
                        />
                      ) : (
                        `${isNaN(row.feeSubCon) ? 0 : row.feeSubCon}%`
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </DialogContent>
        </Dialog>
      )}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
    </div>
  );
}
